import { createColumnHelper } from "@tanstack/react-table";
import { EJOManagementColumns } from "./types";
import {
  EditActionButton,
  PrintActionButton,
} from "../../../../../components/common/primebmd-ui/EditActionButton";

const columnHelper = createColumnHelper<EJOManagementColumns>();

const ejoManagementColumns = [
  columnHelper.accessor("ejoNumber", {
    id: "ejoNumber",
    header: "MRRF No.",
    cell: (row) => row.getValue(),
    enableGlobalFilter: true,
    enableColumnFilter: false,
  }),
  columnHelper.accessor("equipmentNo", {
    id: "equipmentNo",
    header: "Equipment No.",
    cell: (row) => row.getValue(),
    enableGlobalFilter: true,
    enableColumnFilter: true,
  }),
  columnHelper.accessor("projectLocation", {
    id: "projectLocation",
    header: "Project Location",
    cell: (row) => row.getValue(),
    enableGlobalFilter: true,
    enableColumnFilter: true,
  }),
  columnHelper.accessor("daysElapsed", {
    id: "daysElapsed",
    header: "Days Elapsed",
    cell: (row) => row.getValue(),
    enableGlobalFilter: true,
    enableColumnFilter: true,
  }),
  columnHelper.display({
    id: "actions",
    header: "Action",
    cell: ({ row }) => (
      <>
        <EditActionButton route={`/ejo-management/edit/${row.original.id}`} />
        <PrintActionButton
          onClick={() => {
            const url = `${process.env.REACT_APP_API_URL}ejo/pdf/${row.original.id}`;
            window.open(url, "_blank");
          }}
        />
      </>
    ),

    enableHiding: false,
  }),
];

export default ejoManagementColumns;
